import React from "react";
import { ArrowDownRight } from "lucide-react";
import BrandMark from "./BrandMark";

const highlights = ["Islamischer Planner", "Kuratierte Bücher", "Geschenkfertig verpackt"];

export default function Hero() {
    const scrollTo = (id) => {
        const el = document.querySelector(id);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    };

    return (
        <section
            id="willkommen"
            data-testid="hero-section"
            className="relative pt-36 pb-24 md:pt-44 md:pb-32 overflow-hidden bg-cream-50"
        >
            <div
                aria-hidden="true"
                className="absolute inset-0 bg-[radial-gradient(circle_at_20%_10%,rgba(166,138,154,0.18),transparent_32%),radial-gradient(circle_at_85%_20%,rgba(196,160,101,0.18),transparent_30%),linear-gradient(180deg,#FDFBF7_0%,#F6F0E8_100%)]"
            />
            <div
                aria-hidden="true"
                className="absolute top-24 left-1/2 h-px w-[70vw] -translate-x-1/2 bg-gradient-to-r from-transparent via-clay-500/25 to-transparent"
            />

            <div className="relative max-w-6xl mx-auto px-6 md:px-10 grid md:grid-cols-12 gap-12 md:gap-20 items-center">
                <div className="md:col-span-7 reveal">
                    <span className="divider-dot mb-8" data-testid="hero-eyebrow">
                        <span>Premium Stationery · Launch 2026</span>
                    </span>

                    <h1
                        className="font-serif font-light text-5xl sm:text-6xl lg:text-7xl tracking-tight leading-[0.98] text-ink-900"
                        data-testid="hero-heading"
                    >
                        Schreiben mit
                        <br />
                        <em className="italic font-normal text-mauve-500">
                            Ruhe, Sinn und Iman.
                        </em>
                    </h1>

                    <p
                        className="mt-8 max-w-xl text-base md:text-lg text-ink-700 leading-relaxed font-light"
                        data-testid="hero-subtitle"
                    >
                        Dar al Midad gestaltet ästhetische islamische Schreibwaren,
                        Planner und sorgfältig ausgewählte Bücher — für Fokus,
                        Reflexion und die Stärkung deines Imans.
                    </p>

                    <div className="mt-8 flex flex-wrap gap-3">
                        {highlights.map((item) => (
                            <span
                                key={item}
                                className="rounded-full border border-clay-500/15 bg-white/45 px-4 py-2 text-[10px] uppercase tracking-[0.24em] text-ink-700 backdrop-blur"
                            >
                                {item}
                            </span>
                        ))}
                    </div>

                    <div className="mt-10 flex flex-col sm:flex-row items-start sm:items-center gap-5">
                        <button
                            data-testid="hero-cta-newsletter"
                            onClick={() => scrollTo("#newsletter")}
                            className="premium-button group inline-flex items-center gap-3"
                        >
                            Launch vormerken
                            <ArrowDownRight
                                size={16}
                                className="transition-transform group-hover:translate-x-1 group-hover:translate-y-1"
                            />
                        </button>

                        <button
                            data-testid="hero-cta-learn"
                            onClick={() => scrollTo("#planner")}
                            className="text-xs tracking-[0.28em] uppercase text-ink-700 hover:text-ink-900 link-underline font-light"
                        >
                            Planner entdecken
                        </button>
                    </div>
                </div>

                <div
                    className="md:col-span-5 reveal flex justify-center md:justify-end"
                    data-testid="hero-visual"
                >
                    <div className="relative float-slow">
                        <div className="absolute -inset-8 rounded-full bg-white/45 blur-xl" />
                        <div className="relative rounded-full border border-white/70 bg-white/35 p-4 shadow-[0_35px_90px_-45px_rgba(44,39,36,0.45)] backdrop-blur-sm">
                            <BrandMark variant="stacked" testId="hero-logo" />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
